import mutation_types from "./mutation_types.js";
import Vue from 'vue';

export default {
    [mutation_types.SET_MODAL_CONNECT_WITH_DATA](state, data) {
        Object.assign(state.modalConnectWithData, data);
    },
    [mutation_types.SET_MODAL_CONNECT_WITH_OPTIONS](state, options) {
        state.modalConnectWithOptions = options
    },
    [mutation_types.SET_ITEM_ALLOCATION](state, options) {
        let key;
        switch (options.type) {
            case 'operation':
                key = "unallocated_payments";
                break;
            case 'document':
                key = "documents";
                break;
            case 'unallocated_document':
                key = "unallocated_documents";
                break;
        }
        if(key) state.modalConnectWithData[key][options.index].allocation = options.allocation
    },
    [mutation_types.SET_MODAL_CONNECT_WITH_ERRORS](state, errors) {
        state.modalConnectWithData.errors = errors;
    },
    [mutation_types.SET_MODAL_CONNECT_WITH_DATE](state, date) {
        state.modalConnectWithData.settlement_date = date;
    },
    [mutation_types.SET_MODAL_CONNECT_WITH_DESCRIPTION](state, description) {
        Vue.set(state.modalConnectWithData, 'description', description)
    },
    [mutation_types.SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE](state, bool) {
        Vue.set(state.modalConnectWithData, 'currency_exchange', bool)
    },
    [mutation_types.ADD_UNALLOCATED_PAYMENT_TO_MODAL_DATA](state, operation) {
        let index = state.modalConnectWithData.unallocated_payments.findIndex(x => x.id === operation.id);
        if(index < 0) state.modalConnectWithData.unallocated_payments.push(operation);
    },
    [mutation_types.REMOVE_UNALLOCATED_PAYMENT_FROM_MODAL_DATA](state, operation) {
        let index = state.modalConnectWithData.unallocated_payments.findIndex(x => x.id === operation.id);
        if(index >= 0) state.modalConnectWithData.unallocated_payments.splice(index, 1);
    },
}